//BASE URLs – must be set at BUILD time (e.g. in CI/AWS build env or .env.production)
// eslint-disable-next-line no-undef
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
// export const API_BASE_URL = 'http://192.168.2.92:8081/devotee/v1/';

export const API_LOGIN = 'cms/login';
export const API_FORGOT_PASSWORD = 'cms/forgot-password';
export const API_RESET_PASSWORD = 'cms/reset-password';
export const API_CHANGE_PASSWORD = 'cms/change-password';
export const API_LOGOUT = 'user/logout';
export const VERIFY_OTP = 'verify-otp';
export const RESEND_OTP = 'resend-otp';

//DASHBOARD APIs
export const API_DASHBOARD = 'cms/dashboard';

//PROFILE APIs
export const API_PROFILE = 'cms/profile';

//SUB-ADMIN APIs
export const API_SUB_ADMIN = 'cms/sub-admin';

//REPORTS
export const API_EXPORT_REPORT = 'cms/report/export';
export const API_REPORTS = 'cms/report';

//USER APIs
export const API_USER = 'cms/user';
export const API_COMM_USER = 'cms/community/user';
export const API_VENDOR = 'cms/vendor';
export const API_RESTAURANT_ORDER_CHANGE = 'cms/food-restaurant/list/';
export const API_USER_VENDOR = 'cms/user/vendor/list';
export const API_USER_VENDOR_DETAIL = 'cms/vendor/details/';
export const API_USER_SESSION_DELETE = 'cms/delete/user-session/';
export const API_DELETE_REPORTED_COMMENT = `cms/community/post/comments?commentId=`;

//USER Food Busines APIs
export const API_USER_FOOD_BUSINESS_PROFILE = 'cms/food-business/profile';

//BANNER APIs
export const API_BANNER = 'cms/banner';

//BANNER Module APIs
export const API_BANNER_MODULE = 'cms/module';

//TEMPLE APIs
export const API_TEMPLE = 'cms/temple';

//TEMPLE APIs
export const API_PRASAD_TEMPLE = 'cms/prasad/temple';

export const API_SLOT_TEMPLE = 'cms/temple/list';

//ADD RESTAURANT
export const API_ADD_RESTAURANT = 'cms/food-business/profile';

//POOJA APIs
export const API_POOJA = 'cms/pooja';

//TEMPLE SLOT APIs
export const API_TEMPLE_SLOT = 'cms/temple/slot';
export const API_TEMPLE_SLOT_BOOKED = 'cms/temple/slot/request/list';

//Food Catergory APIs
export const API_FOOD_CATEGORY = 'cms/food-category';

//Food Restauant
export const API_RESTAURANT = 'cms/food-restaurant/list';

//Food Catergory Items APIs
export const API_FOOD_ITEM = 'cms/food';

//Food Restaurant Range APIs
export const API_FOOD_RESTAURANT_RANGE = 'cms/food-restaurant-range';

//Product Catergory APIs
export const API_PRODUCT_CATEGORY = 'cms/product/category';

export const API_PRODUCT_CATEGORY_LIST = 'cms/product/category/list';

//Food Product Items APIs
export const API_PRODUCT_ITEM = 'cms/product';

//vendor list
export const API_VENDOR_LIST = 'cms/user/vendor/list';

//Static Page APIs
export const API_STATIC_PAGE = 'cms/static-page';

//Commission APIs
export const API_COMMISSION = 'cms/commission';

//Promo Code APIs
export const API_PROMO_CODE = 'cms/promoCode';

//Orders APIs
export const API_FOOD_ORDERS = 'cms/order';

//Prasadam Orders APIs
export const API_PRASADAM_ORDERS = 'cms/prasad/order';
export const API_PRASHAD_SHIPMENT = 'delhivery/prasad/request/pickup';
export const API_SHIPMENT_LABEL = 'delhivery/shipment';

//Divine shop orders
export const API_DIVINE_SHOP_ORDERS = 'cms/divineShop/order/list';
export const API_DIVINE_SHOP_ORDERS_DETAIL = 'cms/divineShop/order';
export const API_DIVINESHOP_LIST = 'cms/divineShop/list';

//Blocked user APIs
export const API_BLOCKED_USERS = 'cms/user/block';
export const API_COMMUNITY_USERS = 'cms/community/user/list';

//Payout request
export const API_PAYOUT_REQUEST = 'cms/request/list';

//Request for payout
export const API_REQUEST_FOR_PAYOUT = 'cms/user/payout/list';
export const API_REQUEST_FOR_DIVINESHOP = 'cms/divineShop/payout/list';

//Find Commision
export const API_REQUEST_PAYOUT = 'cms/user/request/payout';
export const API_REQUEST_PAYOUT_DS = 'cms/request/payout';
export const API_REQUEST_DIVINESHOP = 'cms/divineShop/payout';

//Admin payout
export const API_REQUEST_PAYOUT_SEND = 'cms/user/payout';

//User posts
export const API_USER_POSTS = 'cms/post';

//Reported posts
export const API_REPORTED_POSTES = 'cms/post/report';

//Accept or reject payout request api
export const API_ACCEPT_REJECT_PAYOUT_REQUEST = 'cms/payout/request/acceptReject';

//Accept or reject priest request api
export const API_ACCEPT_REJECT_PRIEST_REQUEST = 'cms/verifyAsPriest/request/acceptReject';

//Reported comments
export const API_REPORTED_COMMENTS = 'cms/report/comments';

//Reported users
export const API_REPORTED_USERS = 'cms/user/report';

//Delete post by admin
export const API_DELETE_POST_BY_ADMIN = 'cms/post';

export const API_DELETE_COMMUNITY_USER = 'cms/community/user/';

export const API_REASONS = 'user/community/report/reasons/list/1';

export const API_IGNORE_REPORT = 'cms/post/report/';
export const API_IGNORE_REPORT_PROFILE = 'cms/user/report/';
export const API_IGNORE_REPORT_COMMENT = 'cms/post/comments/';

//Post details
export const API_POST_DETAILS = 'cms/post/details';

//Contact us
export const API_GET_CONTACT_US = 'cms/contact-us';

//Email Templates
export const API_GET_EMAIL_TEMPLATES = 'cms/email-template';

//Edit email templates
export const API_EDIT_EMAIL_TEMPLATES = 'cms/email-template';

// Add/edit event or visit for priest
// /devotee/v1/cms/community/events/visits/{priestId}
export const API_ADD_EDIT_EVENT = 'cms/community/events/visits';

//  fetch List of event or visit for priest
// /devotee/v1/cms/community/events/visits/list/{priestId}
export const API_FETCH_EVENT = 'cms/community/events/visits/list';

//  Add/Edit ABOUT for priest by CMS User
// /devotee/v1/cms/community/profile/aboutMe
export const API_ADD_EDIT_ABOUT_PRIEST = 'cms/community/profile/aboutMe';

//  Fetch priest's about me
// /devotee/v1/cms/community/profile/aboutMe/{priestId}
export const API_FETCH_ABOUT_PRIEST = 'cms/community/profile/aboutMe';

//DHAM YATRA
export const API_DHAM = 'cms/dham';
export const API_DHAM_LIST = 'cms/dham/list';
export const API_USER_DHAM_LIST = 'user/dham/list';
export const API_DHAM_CITIES = 'cms/dham/cities';

export const API_PLACE_TO_VISIT = 'cms/dham/placesToVisit';
export const API_PLACE_TO_VISIT_LIST = 'cms/dham/placesToVisit/list';
export const API_PLACE_TO_VISIT_DETAIL = 'cms/dham/placesToVisit/details/';

export const API_ITINERARY_LIST = 'cms/itinerary/list';
export const API_ITINERARY = 'cms/itinerary';
export const API_ITINERARY_DETAIL = 'cms/itinerary/details/';

export const API_HOTEL_BY_ID = 'cms/hotel/list/';
export const API_HOTEL = 'cms/hotel';
export const API_HOTEL_BY_ROOM = 'cms/rooms/list/';
export const API_ROOM = 'cms/hotel/rooms';
export const API_BOOKED_HOTEL = 'cms/hotel/user/booking/list';
export const API_HOTEL_CITY_LIST = 'cms/hotel/cities/list';

export const TAXI_TRANSFER_LIST = 'cms/dham/taxiTransfer/list';
export const TAXI_TRANSFER_ALLOCATE = 'cms/dham/taxiTransfer/allocate/list';
export const TAXI_TRANSFER = 'cms/dham/taxiTransfer';

export const API_BOOK_RIDE = 'cms/dham/bookRide';
export const API_BOOK_GUIDE = 'cms/dham/bookGuide';

export const BOOK_RIDE_LIST = 'cms/dham/bookRide/list';
export const BOOK_GUIDE_LIST = 'cms/dham/bookGuide/list';

export const GUIDE_LIST = 'cms/dham/guide/list';
export const GUIDE = 'cms/dham/guide';
export const UNALOCATED_GUIDE = 'cms/dham/unallocated/guide/list?';

export const DRIVER = 'cms/dham/driver';
export const DRIVER_LIST = 'cms/dham/driver/list';
export const UNALOCATED_DRIVER_TAXI_TRANSFER = 'cms/dham/unallocated/taxiTransfer/driver/list';
export const UNALOCATED_DRIVER = 'cms/dham/unallocated/ride/driver/list';
export const CAR_TYPE = 'cms/dham/carType/list?isActive=true';
export const DRIVER_CAR = 'cms/dham/driver/car';

export const API_ALLOCATE_BOOKRIDE = 'cms/dham/bookRide/allocate/';
export const API_ALLOCATE_TAXI_TRANSFER = 'cms/dham/taxiTransfer/allocate/list';
export const API_ALLOCATE_TAXI_TRANSFER_SUBMIT = 'cms/dham/taxiTransfer/allocate';
export const API_ALLOCATE_BOOKRIDE_SUBMIT = 'cms/dham/bookRide/allocate';

export const API_ALLOCATE_TAXI_TANSFER_DETAIL = 'cms/dham/taxiTransfer/allocate/details';
export const API_ALLOCATE_BOOK_RIDE_DETAIL = 'cms/dham/bookRide/allocate/details';
export const API_ALLOCATE_GUIDE_DETAIL = 'cms/dham/bookGuide/allocate/details';

export const API_ALLOCATE_BOOKRIDE_LIST = 'cms/dham/bookRide/allocate/list';
export const API_ALLOCATE_BOOKGUIDE_LIST = 'cms/dham/bookGuide/allocate/list';
export const API_ALLOCATE_BOOKGUIDE = 'cms/dham/bookGuide/allocate';

export const API_ALLOCATE_TAXITRANSFER_LIST = 'cms/dham/taxiTransfer/allocate/list';
export const API_ALLOCATE_KATHA_LIST = 'cms/allocate/kathakar';

export const API_ACTIVITIES = 'cms/dham/activities';
export const API_ACTIVITIES_LIST = 'cms/dham/activities/list';
export const API_ACTIVITIES_USER_LIST = 'cms/dham/user/activities/list';

export const API_KATHAKAR = 'cms/kathakar';
export const API_PUJARI = 'cms/pujari';

export const API_KATHA = 'cms/katha';
export const API_KATHAKAR_LIST = 'cms/kathakar/list';
export const API_PUJARI_LIST = 'cms/pujari/list';

export const API_KATHA_LIST = 'cms/katha/list';
export const API_KATHA_LIST_UNALLOCATED = 'cms/unallocated/kathakar?userKathaBookingId=';

export const API_POOJACEREMONY = 'cms/poojaCeremony';
export const API_API_POOJACEREMONY_LIST = 'cms/poojaCeremony/list';
export const API_POOJACEREMONY_LIST_BY_POOJARI = 'cms/pujari/poojaCeremony/list';
export const API_POOJARI_LIST_BY_POOJACEREMONY = 'cms/poojaCeremony/pujari/list';
export const API_POOJATYPE_LIST = 'cms/pooja-type';
export const API_POOJACEREMONY_REQUEST_APPROVE_BOOKING = 'cms/approve-booking';

export const API_POOJAPACKAGE = 'cms/poojaPackage';
export const API_POOJAPACKAGE_LIST = 'cms/poojaPackage/list';

export const API_KATHA_REQ_LIST = 'cms/katha/request/list';
export const API_KATHA_REQ_LIST_DETAIL = 'cms/katha/request/details';
export const API_KATHA_ALLOCATE = 'cms/allocate/kathakar';
export const API_POOJA_REQ_LIST = 'cms/poojaCeremony/request/list';
export const API_POOJA_REQ_LIST_DETAIL = 'cms/poojaCeremony/request/details';
export const API_POOJA_ALLOCATE = 'cms/allocate/pujari';
// Same list endpoint as BookedPooja/AutoAssignPooja; isAutoAssign is required by backend
export const API_INSTANT_BOOKING_LIST = 'cms/poojaCeremony/request/list';
// Backend requires isAutoAssign; instant booking list may use same as auto-assign (true)
export const API_INSTANT_BOOKING_LIST_QUERY = 'isAutoAssign=true';
export const API_INSTANT_BOOKING_ACCEPT_REJECT =
    'cms/poojaCeremony/instantBooking/request/{id}?accept={accept}';

// API FOR CANCEL ORDER
export const API_CANCEL_ORDER = 'cms/cancel-order';

export const API_LIST_RESTAURANT = 'cms/food-restaurant/list';
